import { isNullOrUndef } from './utils/isNullOrUndef'
import { dlDispatchAmplEvent } from './events/dl.dispatchAmplEvent'
import { MEDIA_BREAKPOINTS } from './constants/MEDIA_BREAKPOINTS'

import './styles/basic.scss'
import './styles/oldUsedStyles.scss'

// ICON FONT AND ICON CLASSES
// =============================================================================
import './Icons/icons.scss'

// BACKGROUNDS FOR COLOR ICONS
// =============================================================================
import './styles/backgroundsForColors.scss'

// SECTIONS
// =============================================================================
import './Header/header'
import './Sections/section.promo-bar'

// SNIPPETS
// =============================================================================
import './Snippets/breadcrumbs.scss'

// Events
// =============================================================================
import './events/dataLayerEvents' // GTM dataLayer
import './events/amplEventsListener' // Amplitude

// Referrals
// =============================================================================
import './esaid/esaid'

// Custom components
// =============================================================================
import './Components/components'

// Accessibility
// =============================================================================
import { a11yAnchors } from './js/a11y'
a11yAnchors()

// Dynamic imports
// =============================================================================
;(async function () {
  if (
    // if it is nor login/register page
    !window.location.pathname.includes('account/login') &&
    !window.location.pathname.includes('account/register') &&
    !window.location.pathname.includes('account/activate') &&
    !window.location.pathname.includes('account/invalid_token')
  ) {
    // Nav
    if (MEDIA_BREAKPOINTS.XL_UP.matches) {
      // Desktop
      import('./nav-desktop/nav.desktop')
    } else {
      // Mobile
      import('./Sidebars/Mobile menu/mobileMenuSidebarNew')
    }
    // Sidebars
    import('./Sidebars/sidebars')
  }
}())

// Basic functions
// =============================================================================
;(function () {
  document.querySelectorAll('a[href="#"]').forEach(elem => {
    elem.addEventListener('click', evt => {
      evt.preventDefault()
    })
  })

  // Back to top
  document.querySelectorAll('[data-action="back-to-top"]').forEach(elem => {
    elem.addEventListener('click', event => {
      event.preventDefault()
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    })
  })
}())

// EVENTS
// =============================================================================
// GTM
;(function (global) {
  const gtm = global.dataLayer = global.dataLayer || []

  // Sign in with form
  document.querySelectorAll('form[action="/account/login"]').forEach(form => {
    form.addEventListener('submit', () => {
      gtm.push({
        event: 'Sign in',
        contact: {
          email: form.querySelector('input[type="email"]').value,
          location: global.location.pathname
        }
      })
    })
  })
}(window))

// Sign in / Sign up events
;(function () {
  // hiko sign up
  document.addEventListener('hiko', ({ detail }) => {
    if (detail.action === 'multipass' && detail.new_customer) {
      dlDispatchAmplEvent('user_sign_up')
    }
  })

  // check in session storage if user used registration form
  const isNew = window.sessionStorage.getItem('c_reg')
  // and clear for each next page,
  // because after successful registration,
  // user will be logged
  window.sessionStorage.removeItem('c_reg')
  // set flag to session storage that user used registration form
  document.querySelectorAll('form[action="/account"]').forEach(form => {
    form.addEventListener('submit', () => {
      window.sessionStorage.setItem('c_reg', 'true')
    })
  })

  // check in session storage prev value of logged flag
  const isLogged = window.sessionStorage.getItem('c_logged')
  if (isLogged === null) {
    window.sessionStorage.setItem('c_logged', String(!!window.customer?.id))
  }
  // and if prev value is false, and now we see customer id
  // then send event and change flag value
  if (isLogged === 'false' && !!window.customer?.id) {
    if (isNew === 'true') {
      // if user used registration form on the prev page
      dlDispatchAmplEvent('user_sign_up')
    }
    dlDispatchAmplEvent('user_sign_in')
    window.sessionStorage.setItem('c_logged', 'true')
  }

  // but if flag is true and user logout
  if (isLogged === 'true' && !window.customer?.id) {
    window.sessionStorage.setItem('c_logged', 'false')
  }
}())

// Algolia
;(function (global) {
  const Cookies = window.Cookies
  const queryID = Cookies.get('alg_last_queryID') || null
  const index = Cookies.get('alg_last_index') || null

  if (!queryID || !index) return

  Cookies.remove('alg_last_queryID')
  Cookies.remove('alg_last_index')

  document.addEventListener('addToCart', (event) => {
    const sku = ((event.detail || {}).itemData || {}).sku
    if (!sku) {
      return
    }

    const cookieData = Cookies.get('alg_ids_in_cart')
    let arrayIDs = cookieData ? JSON.parse(cookieData) : []

    // delete current sku for update
    arrayIDs = arrayIDs.filter(({ objectID }) => objectID !== sku)

    arrayIDs.push({
      queryID,
      index,
      objectID: sku
    })

    Cookies.set(
      'alg_ids_in_cart',
      JSON.stringify(arrayIDs),
      {
        expires: 1825, // 5 years in days
        sameSite: 'lax'
      }
    )
  })
}(window))

// the event that this file is loaded
// =============================================================================
document.dispatchEvent(new window.CustomEvent('jsThemeLoaded'))

;((global) => {
  global.compositeBannerAB = () => {
    isNullOrUndef(global.Cookies.get('compositeBannerAB')) &&
    global.Cookies.set('compositeBannerAB', '1', { expires: 14 })
  }
})(window)

// Amplitude A/B tests
// =============================================================================
;(() => {
  [
    {
      cookieKey: 'ab_pp-frame-color',
      testFlag: 'pp-frame-color'
    }
  ].forEach(({ cookieKey, testFlag }) => {
    const setFunction = () => {
      const variant = window.AmplExperiment.variant(testFlag).value
      window.Cookies.set(cookieKey, String(variant === 'treatment'))
    }
    let repeats = 0
    const interval = window.setInterval(() => {
      if (window.AmplExperiment?.variant(testFlag)?.value === undefined) {
        if (++repeats === 10) window.clearInterval(interval)
        return
      }
      window.clearInterval(interval)
      setFunction()
    }, 200)
  })
})()
